import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchAuthSession } from "aws-amplify/auth";

/**
 * Create a base API to inject endpoints into elsewhere.
 * Components using this API should import from the injected site,
 * in order to get the appropriate types,
 * and to ensure that the file injecting the endpoints is loaded
 */
export const restApi = createApi({
  reducerPath: "restApi",
  /**
   * A bare bones base query would just be `baseQuery: fetchBaseQuery({ baseUrl: '/' })`
   */
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.VITE_AWS_REST_API_URL!,
    prepareHeaders: async (headers) => {
      const session = await fetchAuthSession();

      const token = session.tokens.idToken.toString();

      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  /**
   * Tag types must be defined in the original API definition
   * for any tags that would be provided by injected endpoints
   */
  tagTypes: [],
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   */
  endpoints: () => ({}),
});
